import { Button } from '../../../layouts/ui/Button'
import PatternSvg from '../../../assets/HomePage/Pattern.svg'

export const NextLevel = () => {
    return (
        <section className="w-full py-12 px-6 md:px-16 lg:px-24 xl:px-36">
            <div
                className="bg-white w-full max-w-[1312px] min-h-[300px] md:min-h-[378px] rounded-lg flex flex-col justify-center items-center space-y-8 md:space-y-10 p-6 md:p-10 mx-auto relative overflow-hidden"
                style={{ backgroundImage: `url(${PatternSvg})`, backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: "center" }}
            >
                <div className="space-y-3">
                    <div className="font-bold space-y-3">
                        <p className="text-center text-2xl sm:text-3xl md:text-4xl lg:text-[48px]">
                            Ready to take your career
                        </p>
                        <p className="bg-gradient-to-r from-primary-300 to-secondary-200 bg-clip-text text-transparent text-center text-2xl sm:text-3xl md:text-4xl lg:text-[48px]">
                            to the next level?
                        </p>
                    </div>
                    <h4 className="text-center text-base sm:text-lg md:text-xl">
                        It only takes 2 minutes to sign up.
                    </h4>
                    <p className="text-center text-sm sm:text-base md:text-lg text-gray-500">
                        Join thousands of professionals who found their perfect match
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 md:gap-10 w-full">
                    <Button
                        variant="primary"
                        className="w-full sm:w-[220px] md:w-[260px] h-[44px] md:h-[48px] text-white"
                        onClick={() => window.location.href = '/signup'}
                    >
                        Join as Job Seeker
                    </Button>
                    {/* <Button
                        className="w-full sm:w-[220px] md:w-[260px] h-[44px] md:h-[48px] text-[#2C25C4] bg-white border border-[#2C25C4]"
                        onClick={() => alert("Employer")}
                    >
                        Join as Employer
                    </Button> */}
                </div>
            </div>
        </section>

    )
}
